module.exports = __webpack_public_path__ + "static/media/salesByStore.57de72aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/app-composer/concierge/images/salesByStore.png
// module id = 274
// module chunks = 0